<script>
export let currentRoute;


import ResourceThumb from 'components/views/my/resources/thumbs/Resource.svelte';
import Loading from 'components/elements/Loading.svelte';
// import Error from 'components/elements/Error.svelte';
import MsgCard from 'components/elements/MsgCard.svelte';


import { auth } from 'store/index.js';


import { get } from 'svelte/store';
import SvelteSeo from 'svelte-seo';



const api_url = app_.env.API_URL;



const token = get(auth).token;




let promise = getResourceCategories();


async function getResourceCategories() {

	const url = `${api_url}coaches/resources`;

	const resp = await fetch(url, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	const result = await resp.json();

	if (!resp.ok) {
		throw new Error(result.detail);
	}

	console.log(result);

	return result;

}

</script>


<style>

.hero {
	margin-bottom: 1rem;
}

.category-section {
	padding-top: 2rem;
	padding-bottom: 2rem;
}

.category-section-title {
	margin-bottom: 2.5rem;
	/*font-size: 1.5rem;*/
	/*font-size: 1.75rem;*/
	font-size: 1.675rem;
	text-decoration: underline;
	color: #1f1f1f;
}

.category-section-title span {
	/*text-decoration: underline;*/
}

</style>



<SvelteSeo
	title='Coaching Resources | AHG Coaches Portal'
	description='Coaching Resources!'
/>


<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				Coaching Resources
			</p>

		</div>

	</div>
	
</section>


{#await promise}

<Loading />

{:then categories}

{#each categories as category}
	
<section class="section category-section">

	<div class="container">

		<div class="columns is-centered">

			<div class="column is-10-desktop is-12-touch">

				<p class="category-section-title">
					<span>{category.name}</span>
				</p>

				<div class="columns is-variable is-4 is-mobile is-multiline">

					{#each category.resources as resource}

						<div class="column is-6-desktop is-12-touch">

							<ResourceThumb {resource} />

						</div>
						
					{/each}

				</div>

			</div>

		</div>

	</div>

</section>


{/each}

{:catch error}

<section class="section" style="padding-top: 1.5rem; padding-bottom: 0;">

	<div class="container">

		<MsgCard msg_show={true} msg_text={error.message} msg_type={'error'} msg_forever={true} />

	</div>

</section>

{/await}





